import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { api, extractError } from '@/lib/api.js';

/**
 * A sala do Google Meet de uma manhã online. O Principal cria (na conta Google
 * que conectou no HackOS); todos da manhã entram pelo mesmo link.
 */
export function SalaDoMeet({
  manhaId,
  link,
  principal,
  aoCriar,
  compacto = false,
}: {
  manhaId: string;
  link: string | null;
  principal: boolean;
  aoCriar: () => void;
  compacto?: boolean;
}) {
  const [erro, setErro] = useState<string | null>(null);
  const criar = useMutation({
    mutationFn: () => api.post(`/conselheiro/manhas/${manhaId}/meet`),
    onSuccess: () => {
      setErro(null);
      aoCriar();
    },
    onError: (e) => setErro(extractError(e).message),
  });

  if (link) {
    return (
      <span className="inline-flex flex-wrap items-center gap-2">
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="rounded-element px-3 py-1.5 text-[10px] font-bold uppercase text-black"
          style={{ background: 'var(--primary)' }}
        >
          Entrar no Meet
        </a>
        {compacto ? null : <span className="break-all text-xs text-ha-muted">{link.replace(/^https:\/\//, '')}</span>}
      </span>
    );
  }
  if (!principal) return <span className="text-xs text-ha-muted">A sala do Meet ainda vai ser criada pelo conselheiro.</span>;
  return (
    <span className="inline-flex flex-wrap items-center gap-2">
      <button
        type="button"
        className="rounded-element border border-ha-border2 px-3 py-1.5 text-[10px] font-bold uppercase text-ha-text disabled:opacity-50"
        disabled={criar.isPending}
        onClick={() => criar.mutate()}
      >
        {criar.isPending ? 'Criando…' : 'Criar a sala do Meet'}
      </button>
      {erro ? <span className="text-xs text-red-600">{erro}</span> : null}
    </span>
  );
}
